<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>短信通知列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.phone" placeholder="输入手机号码"></el-input>
      </el-form-item>
      <el-form-item v-if="user.username == 'admin' ">
        <el-select v-model="formInline.depId" size="small" placeholder="选择部门">
          <el-option v-for="item in deptData" :label="item.departmentName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :header-cell-style="this.$store.state.headerCss" :data="dataList" highlight-current-row v-loading="loadingData" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column  prop="title" sortable label="标题" width="170">
      </el-table-column>
      <el-table-column  prop="phone" sortable label="手机号码" width="120">
      </el-table-column>
      <el-table-column  prop="meterInfoName"  sortable label="计量点" width="240">
      </el-table-column>
      <el-table-column  prop="content" label="内容">
      </el-table-column>
      <el-table-column  prop="createDate" sortable label="发送时间" width="180">
      </el-table-column>
      <el-table-column  prop="blance" sortable label="余额"  width="120">
      </el-table-column>
      <el-table-column  prop="blance" sortable label="发送状态" width="100">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.success" size="small">成功</el-tag>
          <el-tag type="danger" v-if="!scope.row.success" size="small">失败</el-tag>
        </template>

      </el-table-column>

    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog">
      <el-form label-width="100px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="选择部门">


           <el-select v-model="editForm.depId" size="small">
             <el-option v-for="item in deptData" :label="item.departmentName" :value="item.id"></el-option>
           </el-select>
        </el-form-item>
        <el-form-item label="合同名称" prop="contractName">
        	<el-input size="small" v-model="editForm.contractName"></el-input>
        </el-form-item>
        <el-form-item label="短信条数" prop="total">
        	<el-input size="small" v-model="editForm.total"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {departmentList} from '../../api/userMG'
import { getMsgDetailList } from '../../api/summaryMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loadingData:false,
      deptData:[],
      proviceList:[],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
       depId:"",
       phone:"",
       content:"",
       meterInfoName:"",

      },
      dataList:[],
      // rules表单验证
      rules: {
        provincecityName: [
          { required: true, message: '请选择省份', trigger: 'blur' }
        ],

      },
      formInline: {
        depId:"",
        contractName:""
      },

      user:{},
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total:0
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {


    this.user = JSON.parse(sessionStorage.getItem('userdata'))

    if(this.user.username != 'admin'){
      this.formInline.depId = this.user.departmentId
    }else{
      this.formInline.depId = 6
    }


    this.getData()
    // this.getProviceCity()
    this.getdept()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    getDepId(){

    },

    //获取所有的部门信息
    getdept(){

    	departmentList().then(res => {
    		if(res.status == 1){
    			this.deptData = res.data
    		}else{
    			this.$message.error(res.msg)
    		}
    	})
    	.catch(err => {
    	  this.loading = false
    	  this.$message.error('获取部门信息失败，请稍后再试！')
    	})
    },


    getData() {
      let param = {
        ...this.pageparm,
        ...this.formInline
      }
      this.loadingData = true
      getMsgDetailList(param).then(res => {
         this.loadingData = false
        if(res.status == 1){
          this.dataList = res.data.data
          this.pageparm.total = res.data.totalCount
        }else{
          this.$message.error(res.msg)
        }
      })
    },
    getProviceCity:function(){
    	getAllProviceCity().then(res => {
    		if(res.status == 1){
    			this.proviceList = res.data
    		}else{
    			this.$message.error(res.msg)
    		}
    	})
    },


    callFather(parm) {
      this.formInline.currentPage = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getData()

    },
    // 搜索事件
    search() {
      this.getData()
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.depId = row.depId
        this.editForm.contractName = row.contractName
        this.editForm.total = row.total
      } else {
        this.title = '添加'
        this.editForm.id = ""
        this.editForm.depId = ''
        this.editForm.contractName = ""
        this.editForm.total = ""
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
       console.log(valid)


        if (valid) {
          if(this.title == '添加'){
            this.saveData()
          }else{
            this.upDateData()
          }

        } else {
          return false
        }
      })
    },
    saveData(){
      addMsgContract(this.editForm)
        .then(res => {
          this.loading = false
          this.editFormVisible = false
          if (res.status == 1) {
            this.$message({
              type: 'success',
              message: '添加成功！'
            })
            this.getData()
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
    },

    upDateData(){
      modifyMsgContract(this.editForm)
        .then(res => {
          this.loading = false
          this.editFormVisible = false

          if (res.status == 1) {
            this.$message({
              type: 'success',
              message: '修改成功！'
            })
            this.getData()
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
    },

    deleteInfo(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteMsgContract({id:row.id})
            .then(res => {
              if(res.status == 1){
                this.$message.success('删除成功')
                this.getData()
              }else{
                this.$message.error(res.msg)
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>

.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/message/msgList.vue